export const formatValuta = num => {
    return String(parseFloat(num).toFixed(2));
};
